/**
 * Utility function to generate URL-friendly anchors
 * @param text - The text to generate an anchor for
 * @returns The URL-friendly anchor
 */
export const generateAnchor = (text: string): string => {
  return text
    .toLocaleLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single
    .trim();
};
